import stephanProfile from "@/assets/stephan-profile.jpg";
import stephanTeam from "@/assets/stephan-team.jpg";
import burkhardProfile from "@/assets/burkhard-profile.jpg";
import burkhardTeam from "@/assets/burkhard-team.jpg";
import margretTeam from "@/assets/margret-team.jpg";

export type TeamMember = {
  id: string;
  name: string;
  title: string;
  focus: string;
  motto: string;
  imageUrl: string;
  teamImageUrl?: string;
  haltung?: string[];
  intro: string;
  motivation: string;
  expertise: {
    category: string;
    items: string[];
  }[];
  background: {
    category: string;
    items: string[];
  }[];
  schluesselProjekte?: string[];
  ehrenamt?: string[];
  linkedinUrl?: string;
};

export const teamMembers: TeamMember[] = [
  {
    id: "stephan",
    name: "Stephan Rathgeber",
    title: "Geschäftsführer & Berater",
    focus: "Leadership, Kommunikation & Transformation",
    linkedinUrl: "https://www.linkedin.com/in/stephanrathgeber/",
    motto: "Führung heißt für mich: Vorbild sein, gemeinsam gestalten und nachhaltig Wirkung erzielen.",
    imageUrl: stephanTeam,
    teamImageUrl: stephanProfile,
    intro:
      "Führung ist mein Herzensthema. Nah an Menschen, Kunden und echten Herausforderungen. Führung, die Orientierung gibt, Verantwortung teilt und Räume öffnet, in denen andere über sich hinauswachsen können. Zudem bin ich Gründer von Rathgeber Consulting – einer Boutique-Beratung für Marketing, Corporate Influencing, Künstliche Intelligenz und Leadership.",
    motivation:
      "Ich mag Menschen. Das ist für mich nicht nur ein Satz, sondern das Fundament meiner Arbeit. Ich bin fest davon überzeugt, dass echte Wirksamkeit und exzellente Führung nur dort entstehen, wo Kommunikation keine Einbahnstraße ist, sondern ein echter Austausch auf Augenhöhe stattfindet. In meiner Beratung verbinde ich meine Leidenschaft für Führung und Wirksamkeit mit dem tiefen Wunsch, Menschen beim Wachsen zu begleiten. Dabei geht es mir um mehr als nur Prozesse: Es geht um den Kontakt. Mein Ziel ist es, gemeinsam die Welt ein Stück besser zu machen – durch empathische Begleitung, methodische Klarheit und den unbedingten Fokus auf das, was uns als Menschen ausmacht.",
    expertise: [
      {
        category: "Methodische Kompetenz",
        items: [
          "14 Jahre Senior Führungserfahrung sowie diverse Leadership Trainings",
          "Umsetzungs- und Theoriewissen zu strategischen Frameworks (OKR, SWOT, Blue Ocean)",
          "Umfassende Marketing-, Employer Branding- und Vertriebsfertigkeiten",
          "Business Coaching & Sparring von Führungskräften",
          "Facilitation & Training von Gruppen & Teams",
          "Agilisierung",
          "Future Leadership",
          "New Work",
        ],
      },
      {
        category: "Aus- und Weiterbildungen",
        items: [
          "Magister Artium in den Geisteswissenschaften (FAU Erlangen-Nürnberg)",
          "Executive Education in Stanford, HBX, HPI, INSEAD und EBS",
          "Ausbildung zum Systemischen Coach & Berater (mindsystems)",
          "Ausbildung zum Facilitator (Kommunikationslotsen)",
          "Future Leadership Ausbildung (Intrinsify)",
          "AI First School, SHIFT Transformation Program, EMPOWER (Burda)",
        ],
      },
    ],
    schluesselProjekte: [
      "New Hiring und New Leadership Führungsprogramm bei der Caritas Mainz",
      "Führungskräfteprogramm REACH THE SKY bei einer mittelständischen Versicherung",
      "Business Turn-Around (Neue Fische GmbH): Restrukturierung der Organisation und Rückkehr zu Wachstum",
      "Digitale Transformation (HAYS AG): Digitalstrategie, Kulturwandel für >2.000 Mitarbeitende",
      "Strategische Neuausrichtung der New Work SE: Transformation vom Social Network zur Recruiting Company",
    ],
    background: [
      {
        category: "Berufserfahrung",
        items: [
          "Geschäftsführer und CMO, Neue Fische GmbH (2024–2026)",
          "Gründer und Geschäftsführer, Rathgeber Consulting (seit 2024)",
          "Vice President Brand & Marketing, New Work SE / XING, kununu, onlyfy (2021–2024)",
          "Leiter Vorstandsressort Innovation & Digitalisierung, Hays AG (2018–2021)",
          "Director Marketing, Communications & Digital, ManpowerGroup Deutschland (2011–2018)",
          "Communications Manager, Siemens Healthineers (Philadelphia und Erlangen)",
        ],
      },
      {
        category: "Weitere Tätigkeiten",
        items: [
          "Dozent an HWZ, IU, XU Exponential University, Frankfurt School of Finance",
          "Beiratstätigkeit bei CandyLabs GmbH und Horizon GmbH",
          'Buchautor: „New Hiring" und „Blue Hiring"',
        ],
      },
    ],
  },
  {
    id: "margret",
    name: "Dr. Margret Klinkhammer",
    title: "Gründerin & Geschäftsführerin",
    focus: "Systemische Beratung, Coaching & Supervision",
    linkedinUrl: "https://www.linkedin.com/in/margret-klinkhammer-16841239/",
    motto: "Brücken bauen zwischen alt und neu, digital und analog, Ratio und Emotion.",
    imageUrl: margretTeam,
    teamImageUrl: margretTeam,
    haltung: [
      "Achtsam im Kontakt sein und doch zielstrebig am vereinbarten Auftrag arbeiten",
      "Mit hoher Intuition und geleitet von Konzepten vorgehen",
      "Einfühlsam und beharrlich sein",
      "Unterstützende Fragen stellen und gegebenenfalls Anregungen anbieten",
      "Theoriegeleitet und pragmatisch aus vielseitiger Lebens- und Berufserfahrung schöpfen",
    ],
    intro:
      "Viele Jahre war ich Führungskraft und Leitende Angestellte in einem Großkonzern sowie Geschäftsführerin eines Customer Care Centers mit mehr als 1.500 Mitarbeitern an 5 Standorten im In- und Ausland. Seit mehr als 3 Jahrzehnten unterstütze ich junge und ältere Menschen als Beraterin und Mentorin, Coach und Trainerin.",
    motivation:
      "Menschen, ihre Träume und Potentiale, ihre Werte und Glaubenssätze, ihre Zweifel und Hoffnungen sowie ihre suchenden Fragen angesichts der Vielfalt möglicher Antworten sind mir sehr wichtig. Im Kontakt sein und mein Gegenüber als einzigartigen, sich selbst entdeckenden und verändernden Menschen wahrzunehmen: Das ist für jeden von uns eine anspruchsvolle Lebensaufgabe und die Basis meines begleitenden Handelns. Ich konzentriere mich in Begleitung und Beratung darauf, Selbstreflexion zu ermöglichen und das eigene Denken und Handeln zu hinterfragen, und aufgrund von Feedback passendes Interagieren in Teams, Organisationen und im privaten Umfeld zu entwickeln.",
    expertise: [
      {
        category: "Agiles Arbeiten",
        items: [
          "Agile Coaching (ICP-ACC®)",
          "Scrum Product Owner® (ScrumAlliance®)",
          "Agile Leadership (Agile Academy)",
          "Kollegiale Unternehmensführung (nextU)",
        ],
      },
      {
        category: "Mediation & Facilitation",
        items: [
          "Mediatorin BM®",
          "Klein- und Groß-Gruppenformate (Open Space, World Café, Zukunftskonferenzen)",
          "Generative Facilitation (Theory U), Berlin",
        ],
      },
      {
        category: "Training",
        items: [
          "Advanced Scientific Trainerin mit Fokus auf Neurowissenschaft und KI (brain-HR)",
          "Zertifizierte Trainerin & e-Trainerin dvct®",
          "Hypnosystemisches Arbeiten (Milton-Erickson-Institut, Innsbruck)",
        ],
      },
      {
        category: "Coaching & Supervision",
        items: [
          "Eingetragene Supervisorin & Coach (DGSv®, dvct®)",
          "Lehrsupervisorin für DGSv-Präsenz- und Online-Ausbildungen",
          "Narratives Arbeiten",
          "Narrative Organisationsberatung",
          "Teleos Institute (ICF), USA – Executive Coach",
        ],
      },
      {
        category: "Systemisches Arbeiten",
        items: [
          "Systemtheorie Reloaded (Fritz B. Simon, Berlin)",
          "Metatheorie der Veränderung (Klaus Eidenschink, München)",
          "Organisations-Strukturaufstellungen (SySt.-Institut®)",
          "Systemische Organisationsentwicklung (step Berlin, DGSv)",
          "Systemisch-agile OE (Steinbeis Akademie & Kröber)",
          "KI und systemische Organisationsentwicklung (isb, Heidelberg)",
          "Integrale Organisationsentwicklung (IMU Augsburg)",
          "Systemische Organisationsentwicklung – syntaktisch-hynosystemische Entwicklungsberatung (Trigon Schweiz)",
          "Organizational Design for Digital Transformation (MIT, USA)",
        ],
      },
    ],
    background: [
      {
        category: "Akademische Ausbildung",
        items: [
          "Studium und Promotion in Wirtschaftsmathematik, Universität Ulm",
          "Master of Business Administration (MBA), USA",
          "Bachelor Behavioral Science (Soziale Verhaltenswissenschaften), Fernuniversität Hagen",
        ],
      },
      {
        category: "Führungserfahrung",
        items: [
          "Mehr als 20-jährige Führungstätigkeit in einem internationalen DAX-Konzern",
          "Geschäftsführerin eines Customer Care Centers mit 1.500 Mitarbeitenden in 3 Ländern",
          "Seit mehr als 20 Jahren Mitinhaberin eines Familienunternehmens",
        ],
      },
    ],
    ehrenamt: [
      "Seit 1987 Unterstützung Studierender der Universität Ulm im Studium und Beruf",
      "Aufsichtsratsmitglied der Businessforce AG",
      "Mitglied des Universitätsrats der Universität Ulm (2020–2024)",
      "Stv. Aufsichtsratsvorsitzende der IMMA (2016–2025)",
      "Ausbilderin, Dozentin und Supervisorin an diversen Hochschulen",
      'Autorin: „Change Happens \u2013 Veränderungen gehirngerecht gestalten" (3. Auflage, 2024, Haufe Verlag)',
    ],
  },
  {
    id: "burkhard",
    name: "Burkhard Rathgeber",
    title: "Berater & KI-Experte",
    focus: "Soziologie, KI & Systemische Beratung",
    linkedinUrl: "https://www.linkedin.com/in/burkhard-rathgeber/",
    motto: "KI-Systeme und Agenten verändern unsere Arbeitswelt grundlegend. Daher gewinnen menschliche Fähigkeiten wie Autonomie, Beziehungskompetenz und Fokus auf das Gute enorm an Bedeutung. Hier setzt unsere Arbeit auf.",
    imageUrl: burkhardProfile,
    teamImageUrl: burkhardTeam,
    intro:
      "Mein Fokus liegt auf der Schnittstelle von menschlicher Interaktion und digitalem Wandel. Als zertifizierter neuro-systemischer Coach übersetze ich komplexe soziologische Muster in handfeste Lösungen für den Führungsalltag. Besonders dort, wo Künstliche Intelligenz auf klassische Prozessberatung trifft, unterstütze ich Teams dabei, Chancen zu nutzen und Risiken souverän zu managen. Ich begleite Sie mit Empathie, Klarheit und dem Blick für das Wesentliche.",
    motivation:
      "Veränderung verstehen heißt, Interaktion zu begreifen. Mein Fokus liegt auf den Mustern, die unser Handeln und unsere Kommunikation bestimmen – im Team, im Unternehmen und in der Gesellschaft. In einer Welt, in der Künstliche Intelligenz zum neuen Teammitglied wird, begleite ich Sie dabei, diesen Wandel aktiv zu gestalten. Mit soziologischem Tiefgang, KI-Expertise und systemischer Klarheit navigieren wir gemeinsam durch komplexe Transformationen – menschlich auf Augenhöhe, wissenschaftlich fundiert.",
    expertise: [
      {
        category: "KI & Technologie",
        items: [
          "KI im Training (Webinar-Reihe managerSeminare & BRAIN-HR)",
          "ChatGPT: Generative KI für unsere Gesellschaft (Hasso Plattner Institut)",
          "Web Technologies – Backbone of the Emerging Digital World (HPI)",
          "Generative KI in Coaching und Prozessberatung (Abschlussarbeit)",
        ],
      },
      {
        category: "Coaching & Neurowissenschaft",
        items: [
          "Wirksamer Coachen auf drei Gedächtnisebenen (dvct)",
          "Neuropsychologisches Interventionsmodell",
          "COACH-Zustand als Basis für effektive Begleitung",
        ],
      },
      {
        category: "Ausbildung",
        items: [
          "B.A. Soziologie & English/American Studies",
          "Ausbildung zum neuro-systemischen Coach und Prozessberater",
          "Basisseminar Facilitation (IAF-orientiert, Facilitation Academy & teamsysplusAkademie)",
        ],
      },
    ],
    background: [
      {
        category: "Berufserfahrung",
        items: [
          "Berater & KI-Experte, Leadership Focus GmbH",
          "Digital-Koordinator, Leadership Focus GmbH",
          "Media Relations & Thought Leadership, Siemens Smart Infrastructure",
          "Studentische Hilfskraft, Institut für Allgemeinmedizin, Uniklinikum Erlangen",
        ],
      },
      {
        category: "Weitere Erfahrungen",
        items: [
          "Koch, Barchef, Servicekraft, Serviceberater",
          "Freiwilliges Soziales Jahr bei der Lebenshilfe – Pflege & Betreuung von Menschen mit Behinderung",
        ],
      },
    ],
  },
];
